import { AUTH_ANALYTICS_PATHS } from './AnalyticsTracker.constants'

type CanTrackAnalyticsPageParams = {
  pathname: string
  userId?: number
  organizationId?: number
}

export const hasValidAnalyticsId = (value: unknown): value is number =>
  typeof value === 'number' && Number.isFinite(value)

export const isAuthAnalyticsPath = (pathname: string) =>
  AUTH_ANALYTICS_PATHS.some(
    path => pathname === path || pathname.startsWith(`${path}/`)
  )

export const canTrackAnalyticsPage = ({
  pathname,
  userId,
  organizationId
}: CanTrackAnalyticsPageParams) => {
  if (isAuthAnalyticsPath(pathname)) {
    return true
  }

  return hasValidAnalyticsId(userId) && hasValidAnalyticsId(organizationId)
}
